module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 115);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/id");

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ StepBar_StepBar; });
__webpack_require__.d(__webpack_exports__, "Step", function() { return /* reexport */ StepBar_Step; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "@splunk/ui-utils/id"
var id_ = __webpack_require__(10);

// EXTERNAL MODULE: external "@splunk/themes/useSplunkTheme"
var useSplunkTheme_ = __webpack_require__(38);
var useSplunkTheme_default = /*#__PURE__*/__webpack_require__.n(useSplunkTheme_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/themes"
var themes_ = __webpack_require__(0);

// EXTERNAL MODULE: external "@splunk/react-icons/Error"
var Error_ = __webpack_require__(63);
var Error_default = /*#__PURE__*/__webpack_require__.n(Error_);

// EXTERNAL MODULE: ./src/icons/ThemedIcon.tsx
var ThemedIcon = __webpack_require__(7);

// EXTERNAL MODULE: ./src/icons/SVG.tsx
var SVG = __webpack_require__(6);

// CONCATENATED MODULE: ./src/icons/Alert.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






function Prisma24(_ref) {
  var otherProps = _extends({}, _ref);

  return /*#__PURE__*/external_react_default.a.createElement(SVG["a" /* default */], _extends({
    viewBox: "0 0 24 24"
  }, otherProps), /*#__PURE__*/external_react_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM13.2003 15.8001C13.2003 16.4628 12.663 17.0001 12.0003 17.0001C11.3376 17.0001 10.8003 16.4628 10.8003 15.8001C10.8003 15.1374 11.3376 14.6001 12.0003 14.6001C12.663 14.6001 13.2003 15.1374 13.2003 15.8001ZM11.0005 7.9906V12.0001C11.0005 12.5524 11.4482 13.0001 12.0005 13.0001C12.5528 13.0001 13.0005 12.5524 13.0005 12.0001V7.9906C13.0005 7.43832 12.5528 6.9906 12.0005 6.9906C11.4482 6.9906 11.0005 7.43832 11.0005 7.9906Z",
    fill: "currentColor"
  }));
}

function AlertFilled(props) {
  return /*#__PURE__*/external_react_default.a.createElement(ThemedIcon["a" /* default */], _extends({
    Enterprise: Error_default.a,
    Prisma24: Prisma24
  }, props));
}
// EXTERNAL MODULE: external "@splunk/react-icons/Success"
var Success_ = __webpack_require__(64);
var Success_default = /*#__PURE__*/__webpack_require__.n(Success_);

// CONCATENATED MODULE: ./src/icons/Success.tsx
function Success_extends() { Success_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Success_extends.apply(this, arguments); }






function Success_Prisma24(_ref) {
  var otherProps = Success_extends({}, _ref);

  return /*#__PURE__*/external_react_default.a.createElement(SVG["a" /* default */], Success_extends({
    viewBox: "0 0 24 24"
  }, otherProps), /*#__PURE__*/external_react_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.8739 10.0405C17.2645 9.64996 17.2645 9.01679 16.8739 8.62627C16.4834 8.23574 15.8502 8.23574 15.4597 8.62627L10.5247 13.5613L8.5405 11.5776C8.14992 11.1872 7.51675 11.1873 7.12629 11.5779C6.73582 11.9684 6.73591 12.6016 7.12649 12.9921L9.46426 15.3291C10.0501 15.9148 10.9997 15.9147 11.5854 15.329L16.8739 10.0405Z",
    fill: "currentColor"
  }));
}

function SuccessFilled(props) {
  return /*#__PURE__*/external_react_default.a.createElement(ThemedIcon["a" /* default */], Success_extends({
    Enterprise: Success_default.a,
    Prisma24: Success_Prisma24
  }, props));
}
// CONCATENATED MODULE: ./src/StepBar/StepStyles.ts




var iconWrapper = Object(external_styled_components_["css"])(["align-items:center;height:24px;width:24px;margin:0 14px 0 16px;"]);
var StyledSuccess = external_styled_components_default()(SuccessFilled).withConfig({
  displayName: "StepStyles__StyledSuccess",
  componentId: "sc-756fxp-0"
})(["", ";color:", ";"], iconWrapper, themes_["variables"].accentColorPositive);
var StyledAlert = external_styled_components_default()(AlertFilled).withConfig({
  displayName: "StepStyles__StyledAlert",
  componentId: "sc-756fxp-1"
})(["", ";color:", ";"], iconWrapper, themes_["variables"].accentColorNegative);
var Styled = external_styled_components_default.a.li.withConfig({
  displayName: "StepStyles__Styled",
  componentId: "sc-756fxp-2"
})(["", " ", ";text-align:center;padding:", ";", ";", ""], themes_["mixins"].reset('block'), Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["position:relative;flex:1 1 0;"]),
  prisma: Object(external_styled_components_["css"])(["display:flex;align-items:center;flex:0 1 auto;margin:0 12px 0 12px;"])
}), Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["25px 15px 0"]),
  prisma: {
    comfortable: '8px 8px 8px 0',
    compact: '4px 8px 4px 0'
  }
}), Object(themes_["pick"])({
  prisma: Object(external_styled_components_["css"])(["&::before{align-items:center;box-sizing:border-box;border-radius:50%;counter-increment:", ";content:counter(", ");display:inline-flex;flex-shrink:0;font-size:12px;height:20px;width:20px;justify-content:center;line-height:20px;margin:2px 16px 2px 18px;}"], function (_ref) {
    var $idCounter = _ref.$idCounter;
    return $idCounter;
  }, function (_ref2) {
    var $idCounter = _ref2.$idCounter;
    return $idCounter;
  })
}), Object(themes_["pickVariant"])('$status', {
  error: {
    prisma: Object(external_styled_components_["css"])(["color:", ";&::before{visibility:hidden;position:absolute;}"], themes_["variables"].contentColorActive)
  },
  active: {
    prisma: Object(external_styled_components_["css"])(["color:", ";&::before{color:", ";background:", ";border:1px solid ", ";}"], themes_["variables"].contentColorActive, themes_["variables"].contentColorInverted, themes_["variables"].contentColorActive, themes_["variables"].contentColorActive)
  },
  next: {
    enterprise: Object(external_styled_components_["css"])(["color:", ";"], themes_["variables"].textDisabledColor),
    prisma: Object(external_styled_components_["css"])(["color:", ";&::before{color:", ";border:1px solid ", ";}"], themes_["variables"].contentColorMuted, themes_["variables"].contentColorMuted, themes_["variables"].contentColorMuted)
  },
  prev: {
    prisma: Object(external_styled_components_["css"])(["color:", ";&::before{visibility:hidden;position:absolute;}"], themes_["variables"].contentColorDefault)
  }
}));
var StyledSvg = external_styled_components_default.a.svg.withConfig({
  displayName: "StepStyles__StyledSvg",
  componentId: "sc-756fxp-3"
})(["position:absolute;left:0;right:0;top:0;"]);
var StyledPrevOrActiveRect = external_styled_components_default.a.rect.withConfig({
  displayName: "StepStyles__StyledPrevOrActiveRect",
  componentId: "sc-756fxp-4"
})(["fill:", ";"], themes_["variables"].interactiveColorPrimary);
var StyledPrevOrActiveCircle = StyledPrevOrActiveRect.withComponent('circle');
var StyledGray = external_styled_components_default.a.rect.withConfig({
  displayName: "StepStyles__StyledGray",
  componentId: "sc-756fxp-5"
})(["fill:", ";"], themes_["variables"].textDisabledColor);
var StyledNext = external_styled_components_default.a.circle.withConfig({
  displayName: "StepStyles__StyledNext",
  componentId: "sc-756fxp-6"
})(["stroke:", ";stroke-width:3px;fill:", ";"], themes_["variables"].textDisabledColor, themes_["variables"].backgroundColor);

// CONCATENATED MODULE: ./src/StepBar/Step.tsx
function Step_extends() { Step_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Step_extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var propTypes = {
  children: external_prop_types_default.a.node,
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),
  error: external_prop_types_default.a.bool,
  idCounter: external_prop_types_default.a.string,
  isFirst: external_prop_types_default.a.bool,
  isLast: external_prop_types_default.a.bool,
  status: external_prop_types_default.a.oneOf(['prev', 'active', 'next']),
  stepId: external_prop_types_default.a.any
};

function Step(_ref) {
  var children = _ref.children,
      elementRef = _ref.elementRef,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      idCounter = _ref.idCounter,
      _ref$isFirst = _ref.isFirst,
      isFirst = _ref$isFirst === void 0 ? false : _ref$isFirst,
      _ref$isLast = _ref.isLast,
      isLast = _ref$isLast === void 0 ? false : _ref$isLast,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? 'next' : _ref$status,
      stepId = _ref.stepId,
      otherProps = _objectWithoutProperties(_ref, ["children", "elementRef", "error", "idCounter", "isFirst", "isLast", "status", "stepId"]);

  // @docs-props-type StepPropsBase
  var _useSplunkTheme = useSplunkTheme_default()(),
      family = _useSplunkTheme.family;

  if (family === 'enterprise') {
    return /*#__PURE__*/external_react_default.a.createElement(Styled, Step_extends({
      $status: status,
      "data-test-status": status,
      "data-test": "step",
      "data-test-step-id": stepId,
      ref: elementRef
    }, otherProps), /*#__PURE__*/external_react_default.a.createElement(StyledSvg, {
      focusable: "false",
      width: "100%",
      height: "15px",
      viewBox: "0 0 100 15",
      preserveAspectRatio: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/external_react_default.a.createElement(StyledGray, {
      x: isFirst ? '50' : '0',
      y: "6",
      width: isLast || isFirst ? '50%' : '100%',
      height: "3"
    }), (status === 'active' || status === 'error') && !isFirst && /*#__PURE__*/external_react_default.a.createElement(StyledPrevOrActiveRect, {
      x: "0",
      y: "6",
      width: "50%",
      height: "3"
    }), status === 'prev' && /*#__PURE__*/external_react_default.a.createElement(StyledPrevOrActiveRect, {
      x: isFirst ? '50%' : '0',
      y: "6",
      width: "100%",
      height: "3"
    })), /*#__PURE__*/external_react_default.a.createElement(StyledSvg, {
      focusable: "false",
      width: "100%",
      height: "15px",
      viewBox: "0 0 15 15",
      xmlns: "http://www.w3.org/2000/svg"
    }, status !== 'next' && /*#__PURE__*/external_react_default.a.createElement(StyledPrevOrActiveCircle, {
      cx: "50%",
      cy: "50%",
      r: "7.5"
    }), status === 'next' && /*#__PURE__*/external_react_default.a.createElement(StyledNext, {
      cx: "50%",
      cy: "50%",
      r: "6"
    })), children);
  }

  return /*#__PURE__*/external_react_default.a.createElement(Styled, Step_extends({
    $status: status,
    "data-test-status": status,
    "data-test": "step",
    "data-test-step-id": stepId,
    $idCounter: idCounter,
    ref: elementRef
  }, otherProps), status === 'prev' && /*#__PURE__*/external_react_default.a.createElement(StyledSuccess, null), status === 'error' && /*#__PURE__*/external_react_default.a.createElement(StyledAlert, null), children);
}

Step.propTypes = propTypes;
/* harmony default export */ var StepBar_Step = (Step);
// CONCATENATED MODULE: ./src/StepBar/StepBarStyles.ts


var StepBarStyles_Styled = external_styled_components_default.a.ul.withConfig({
  displayName: "StepBarStyles__Styled",
  componentId: "sc-13bf2x4-0"
})(["", ";", ";", ";"], themes_["mixins"].reset('flex'), Object(themes_["pick"])({
  prisma: Object(external_styled_components_["css"])(["position:relative;display:flex;counter-reset:", ";"], function (_ref) {
    var $idCounter = _ref.$idCounter;
    return $idCounter;
  })
}), function (_ref2) {
  var $inline = _ref2.$inline;
  return $inline && Object(external_styled_components_["css"])(["display:inline-flex;"]);
});

// CONCATENATED MODULE: ./src/StepBar/StepBar.tsx
function StepBar_extends() { StepBar_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return StepBar_extends.apply(this, arguments); }

function StepBar_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = StepBar_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function StepBar_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var StepBar_propTypes = {
  activeStepId: external_prop_types_default.a.any.isRequired,
  children: external_prop_types_default.a.node,
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),
  inline: external_prop_types_default.a.bool
};

function StepBar(_ref) {
  var activeStepId = _ref.activeStepId,
      children = _ref.children,
      elementRef = _ref.elementRef,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      otherProps = StepBar_objectWithoutProperties(_ref, ["activeStepId", "children", "elementRef", "inline"]);

  // @docs-props-type StepBarPropsBase
  var _useRef = Object(external_react_["useRef"])(Object(id_["createDOMID"])('stepbar')),
      idCounter = _useRef.current;

  var activeIndex = 0;
  var foundActive = false;
  var validChildren = external_react_["Children"].toArray(children).filter(external_react_["isValidElement"]);
  var lastChildIndex = validChildren.length - 1;
  var clonedChildren = validChildren.map(function (child, idx) {
    var stepId = child.props.stepId || idx;
    var error = child.props.error;
    var active = activeStepId === stepId;
    var childProps = {
      status: 'prev',
      stepId: stepId,
      idCounter: idCounter
    };

    if (foundActive) {
      childProps.status = 'next';
    }

    if (active && !error) {
      childProps.status = 'active';
      foundActive = true;
      activeIndex = idx;
    }

    if (active && error) {
      childProps.status = 'error';
      foundActive = true;
      activeIndex = idx;
    }

    if (idx === 0) {
      childProps.isFirst = true;
    }

    if (idx === lastChildIndex) {
      childProps.isLast = true;
    }

    return /*#__PURE__*/Object(external_react_["cloneElement"])(child, childProps);
  });
  return /*#__PURE__*/external_react_default.a.createElement(StepBarStyles_Styled, StepBar_extends({
    $inline: inline,
    "data-test": "step-bar",
    "data-test-active-step-id": activeStepId // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    ,
    role: "progressbar",
    "aria-valuemin": 1,
    "aria-valuemax": lastChildIndex + 1,
    "aria-valuenow": activeIndex + 1,
    $idCounter: idCounter,
    ref: elementRef
  }, otherProps), clonedChildren);
}

StepBar.propTypes = StepBar_propTypes;
StepBar.Step = StepBar_Step;
/* harmony default export */ var StepBar_StepBar = (StepBar);

// CONCATENATED MODULE: ./src/StepBar/index.ts



/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes/useSplunkTheme");

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVG; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Styled = styled_components__WEBPACK_IMPORTED_MODULE_1___default.a.svg.withConfig({
  displayName: "SVG__Styled",
  componentId: "sc-1bz0ryh-0"
})(["flex:0 0 auto;"]);
function SVG(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Styled, _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props));
}

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Error");

/***/ }),

/***/ 64:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Success");

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _splunk_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _splunk_themes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_splunk_themes__WEBPACK_IMPORTED_MODULE_2__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var inlineStyles = {
  display: 'inline-block',
  flex: '0 0 auto',
  overflow: 'visible',
  verticalAlign: 'middle'
};
var blockStyles = {
  display: 'block',
  flex: '0 0 auto',
  margin: '0 auto',
  overflow: 'visible'
};
var propTypes = {
  Enterprise: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  enterpriseSize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
  enterpriseWidth: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
  enterpriseHeight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
  Prisma24: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  Prisma20: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  Prisma16: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  prismaSize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['medium', 'small']),
  inline: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  screenReaderText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
var defaultProps = {
  inline: true,
  prismaSize: 'medium'
};
function Icon(_ref) {
  var Enterprise = _ref.Enterprise,
      Prisma24 = _ref.Prisma24,
      Prisma20 = _ref.Prisma20,
      Prisma16 = _ref.Prisma16,
      prismaSize = _ref.prismaSize,
      inline = _ref.inline,
      enterpriseSize = _ref.enterpriseSize,
      enterpriseWidth = _ref.enterpriseWidth,
      enterpriseHeight = _ref.enterpriseHeight,
      screenReaderText = _ref.screenReaderText,
      otherProps = _objectWithoutProperties(_ref, ["Enterprise", "Prisma24", "Prisma20", "Prisma16", "prismaSize", "inline", "enterpriseSize", "enterpriseWidth", "enterpriseHeight", "screenReaderText"]);

  var _useSplunkTheme = Object(_splunk_themes__WEBPACK_IMPORTED_MODULE_2__["useSplunkTheme"])(),
      family = _useSplunkTheme.family,
      density = _useSplunkTheme.density; // Enterprise - all variants


  if (family === 'enterprise') {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Enterprise, _extends({
      size: enterpriseSize,
      width: enterpriseWidth,
      height: enterpriseHeight,
      screenReaderText: screenReaderText || null,
      hideDefaultTooltip: true,
      inline: inline
    }, otherProps));
  }

  var prismaProps = _objectSpread({
    'aria-label': screenReaderText,
    style: inline ? inlineStyles : blockStyles
  }, otherProps); // Prisma - small+compact, small+comfortable


  if (prismaSize === 'small') {
    var SVG = Prisma16 || Prisma24;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SVG, _extends({
      width: "16",
      height: "16"
    }, prismaProps));
  } // Prisma - medium+compact


  if (density === 'compact') {
    var _SVG = Prisma20 || Prisma24;

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_SVG, _extends({
      width: "20",
      height: "20"
    }, prismaProps));
  } // Prisma - medium+comfortable


  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Prisma24, _extends({
    width: "24",
    height: "24"
  }, prismaProps));
}
Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

/***/ })

/******/ });